/*!

=========================================================
* Material Dashboard Angular - v2.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-angular2
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/material-dashboard-angular2/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import 'hammerjs';
import { config } from './app/config';

if (environment.production) {
  enableProdMode();
}

fetch('./assets/config.json')
    .then(response => {
        if (!response.ok) {
            throw new Error('Unable to load config.json');
        }
        return response.json();
    })
    .then(data => {
        Object.assign(config, data);
        return platformBrowserDynamic().bootstrapModule(AppModule);
    })
    .catch(error => {
        console.error('Configuration loading failed:', error);
    });
